import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { useAuth } from "../../context/AuthContext";
import config from "../config/api.config";
import "./BannerReminder.css";

const BannerReminder = () => {
  const { isLoggedIn, loading } = useAuth();
  const { pathname } = useLocation();
  const [banner, setBanner] = useState(null);
  const visible = isLoggedIn && !loading && pathname === "/";

  useEffect(() => {
    setBanner(null);
    if (!visible) return undefined;
    const controller = new AbortController();
    let active = true;
    let pending = false;
    const refresh = async () => {
      if (pending) return;
      pending = true;
      try {
        const response = await axios.get(config.apiUrl + config.endpoints.publicBanners, {
          params: { position: "home" }, signal: controller.signal,
        });
        if (active) setBanner(response.data.status === "success"
          ? response.data.data?.banners?.find(item => item.image) || null : null);
      } catch {
        if (active) setBanner(null);
      } finally { pending = false; }
    };
    refresh();
    // Pick up banners hidden/deleted by the admin while the home page stays open.
    const timer = setInterval(refresh, 60000);
    window.addEventListener("focus", refresh);
    return () => {
      active = false;
      controller.abort();
      clearInterval(timer);
      window.removeEventListener("focus", refresh);
    };
  }, [visible]);

  if (!visible || !banner) return null;
  return (
    <aside className="competition-reminder" aria-label="Competition reminder">
      <img src={banner.image} alt={banner.competitionName || banner.title || "Current competition"}
        onError={() => setBanner(null)} />
    </aside>
  );
};

export default BannerReminder;
